import { useState, useEffect } from "react";
import axios from "axios";
import { BellRing } from "lucide-react";
import { useI18n } from "../../i18n";

const API = "/api";

// iter67 F5 — public alert counter. Renders NOTHING unless the admin toggle
// SHOW_PUBLIC_COUNTER is ON (default OFF). Metric: real alert pushes only.
export const PublicCounter = () => {
  const [stats, setStats] = useState(null);
  const { t } = useI18n();

  useEffect(() => {
    axios.get(`${API}/public/stats`)
      .then((r) => { if (r.data?.enabled) setStats(r.data); })
      .catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <div className="border-b border-slate-200 bg-[#EAF4FF]" data-testid="public-counter">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-5 sm:px-6 lg:px-8">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1B84FF]/15">
          <BellRing className="h-4 w-4 text-[#1B84FF]" />
        </span>
        <p className="text-sm text-slate-600">
          <span className="mr-1.5 text-lg font-bold text-[#0B2545]" data-testid="public-counter-value">
            {stats.alerts_delivered.toLocaleString()}
          </span>
          {t("counter.label")}
        </p>
      </div>
    </div>
  );
};

export default PublicCounter;
